import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  Image,
  IconButton,
} from "@chakra-ui/react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Link } from "react-router-dom";

import IAppointment from "../../../assets/services/book-appointment.png";
import IPersonalisation from "../../../assets/services/personalisation.png";
import ICareWear from "../../../assets/services/care-wear.png";
import IOrderInfo from "../../../assets/services/order-info.png";
// import IFAQ from "../../../assets/services/FAQ.png";
// import IArtOfGiving from "../../../assets/services/art-of-giving.png";
import dotActiveImg from "../../../assets/home/Vector.png"; // dot for active bullet

const services = [
  {
    image: IAppointment,
    title: "Book an Appoinment",
    description:
      "Enjoy a personalised shopping experience at your favourite R'rumi Diamond boutique or from the comfort of your own home.",
    url: "/appointment",
  },
  {
    image: IPersonalisation,
    title: "Customization & Personal Touches",
    description:
      "From hot stamping to engraving, discover how to make your R'rumi Diamond creation truly unique.",
    url: "/services/customizationandpersonaltouches",
  },
  {
    image: ICareWear,
    title: "Lifetime Care & Repairs",
    description:
      "Explore our expert tips and learn how to look after your favourite R'rumi Diamond pieces",
    url: "/services/lifetimecareandrepairs",
  },
  // {
  //   image: IArtOfGiving,
  //   title: "The art of gifting",
  //   description:
  //     "A R'rumi Diamond creation hand-wrapped in our signature R'rumi Diamond box is perfect for any occasion.",
  //   url: "/services/theartgifting",
  // },
  // {
  //   image: IFAQ,
  //   title: "Frequently Asked Questions",
  //   description:
  //     "Enjoy a personalised shopping experience at your favourite R'rumi Diamond boutique or from the comfort of your own home.",
  //   url: "/services/undefined",
  // },
  {
    image: IOrderInfo,
    title: "Order Information",
    description:
      "Get all the information to follow the shipping status and track your order.",
    url: "/services/orderinformation",
  },
];

const OurServices = () => {
  return (
    <Box py={12} bg="white" position="relative">
      <Container maxW="container.xl" textAlign="center">
        <Heading
          fontSize={{ base: "lg", md: "2xl" }}
          mb={6}
          color="black"
          borderBottom="2px solid #BFA585"
          display="inline-block"
          fontWeight={"light"}
        >
          Our Services
        </Heading>

        {/* Custom Arrow Buttons */}
        <Box
          position="absolute"
          top={{ base: "40px", md: "60px" }}
          right={{ base: "20px", md: "120px" }}
          display="flex"
          flexDirection="row"
          gap="10px"
          zIndex="10"
        >
          <IconButton
            className="our-service-prev"
            icon={<ChevronLeftIcon />}
            aria-label="Previous"
            variant="ghost"
            fontSize="2xl"
            color="#BFA585"
            _hover={{ bg: "transparent", color: "#8c6b3d" }}
          />
          <IconButton
            className="our-service-next"
            icon={<ChevronRightIcon />}
            aria-label="Next"
            variant="ghost"
            fontSize="2xl"
            color="#BFA585"
            _hover={{ bg: "transparent", color: "#8c6b3d" }}
          />
        </Box>

        {/* Swiper with matching bullet style */}
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          spaceBetween={20}
          slidesPerView={3}
          loop={true}
          autoplay={{ delay: 2500 }}
          navigation={{
            nextEl: ".our-service-next",
            prevEl: ".our-service-prev",
          }}
          pagination={{
            clickable: true,
            renderBullet: (index, className) => {
              return `<span class="${className} custom-bullet"></span>`;
            },
          }}
          breakpoints={{
            320: { slidesPerView: 1 },
            600: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
          style={{ paddingBottom: "20px" }}
        >
          {/* Custom Swiper Bullet & Navigation Styles */}
          <style>
            {`
              .swiper-button-next::after,
              .swiper-button-prev::after {
                display: none;
              }

              .custom-bullet {
                width: 12px;
                height: 12px;
                border-radius: 50%;
                background-color: #bbb;
                margin: 0 4px;
                display: inline-block;
              }

              .swiper-pagination-bullet-active.custom-bullet {
                background-image: url(${dotActiveImg});
                transform: scale(1.3);
                background-size: cover;
                background-position: center;
                background-repeat: no-repeat;
                background-color: transparent;
              }
            `}
          </style>

          {services.map((service, index) => (
            <SwiperSlide key={index}>
              <Link to={service.url}>
                <Box
                  bg="white"
                  boxShadow="md"
                  borderRadius="lg"
                  overflow="hidden"
                  mb={6}
                >
                  <Image
                    src={service.image}
                    alt={service.title}
                    width="100%"
                    height="300px"
                    objectFit="cover"
                  />
                  <VStack spacing={2} mt={4} p={4} textAlign="center">
                    <Text fontSize="lg" fontWeight="thin" color="black">
                      {service.title}
                    </Text>
                    <Text fontSize="12px" color="gray.600">
                      {service.description}
                    </Text>
                  </VStack>
                </Box>
              </Link>
            </SwiperSlide>
          ))}
        </Swiper>
      </Container>
    </Box>
  );
};

export default OurServices;
